export default [
  {
    name: { it: "Ufficio", en: "Office" },
    image: require("./images/ufficio.png"),
    index: 1,
  },
  {
    name: { it: "Ricezione", en: "Accomodation" },
    image: require("./images/ricezione.png"),
    index: 3,
  },
  {
    name: { it: "Spazi commerciali", en: "Commercial spaces" },
    image: require("./images/spazi.png"),
    index: 2,
  },
];
